import { Avatar, Box, Button, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';

const FriendsConnection = ({ id, name, communityGroupAdmin, pictureUrl, category, communityGroupMembers, description, createdAt }) => {
    const navigate = useNavigate();

    const handleViewProfile = () => {
        navigate('/groups-page', {
            state: {
                selectedGroup: {
                    id,
                    name,
                    communityGroupAdmin,
                    pictureUrl,
                    category,
                    communityGroupMembers,
                    description,
                    createdAt,
                },
                activeTab: 0, // Pass activeTab index for Group Info
                showJoinButton: !communityGroupMembers?.some(
                    (member) => member.patient?.id === Number(sessionStorage.getItem("userId"))
                ), // Show "Join this Group" button if not a member
            },
        });
    };

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <Box sx={{
                flexBasis: "60%"
            }} display="flex" alignItems="center">
                <Avatar src={pictureUrl} alt={name} sx={{ width: 40, height: 40, mr: 1 }} />
                <Box sx={{ flexBasis: "80%" }}>
                    <Typography sx={{ width: "100%" }} variant="body2" fontWeight={500} fontSize="small">
                        {name}
                    </Typography>
                    {/* <Typography variant="caption" color="text.secondary">
                        {category?.name}
                    </Typography> */}
                </Box>
            </Box>
            <Button
                onClick={handleViewProfile}
                variant="contained"
                sx={{
                    bgcolor: '#29BA2E',
                    textTransform: 'none',
                    fontSize: 12,
                    px: 2,
                    py: 0.5,
                    borderRadius: 4,
                    minWidth: 80,
                }}
            >
                View Profile
            </Button>
        </Box>
    );
};

export default FriendsConnection;